<template>
  <v-container class="cmp-accounting-invoice_reminder-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              (selectedInvoiceReminder &&
                selectedInvoiceReminder.invoice_reminder &&
                selectedInvoiceReminder.invoice_reminder.subject) ||
                ''
            "
          >
            <span
              v-if="
                selectedInvoiceReminder.invoice_reminder &&
                  selectedInvoiceReminder.invoice_reminder
              "
              >{{
                selectedInvoiceReminder.invoice_reminder.subject || $t('reminders')
              }}
            </span>
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <!-- <div class="ut-flex">
              <div
                v-if="selectedLicenceAccountDetails && selectedLicenceAccountDetails.licence_account"
              >
                {{
                  selectedLicenceAccountDetails.licence_account.royalty_account_name ||
                  "Account Name"
                }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <glayout
        :tabs="invoiceReminderSidewindowTabs"
        :loading="selectedInvoiceReminder && selectedInvoiceReminder.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedInvoiceReminder &&
                      selectedInvoiceReminder.invoice_reminder_contacts &&
                      selectedInvoiceReminder.invoice_reminder_contacts.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
                :title="$t('contact')"
              >
                <InvoiceReminderContactList
                  :selectedInvoiceReminder="selectedInvoiceReminder"
                  @deleted="onInvoiceReminderContactDeleted"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <!-- Sidewindow -->

    <template v-if="contact_invoicesModalContainer">
      <v-dialog v-model="contact_invoicesModal" persistent width="800">
        <InvoiceReminderContactsEdit
          :selectedInvoiceReminder="selectedInvoiceReminder"
          @cancelled="onContactInvoicesCancelled"
        />
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { AccountingStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import BoxWidget from "@plugins/box-widget/box-widget";

import { mapKeyToAction } from "../../../../store/global";
import { encodeRoute, openWindow } from "../../../../utility";
import { bookingListCalendarDateTabRoute } from "../../../booking/router/router";
import { HttpClient } from "../../../../services/http/http-client";
import {
  invoiceListLDTRoutes,
  invoiceReminderListLDTRoutes
} from "../../router/routes";

import InvoiceReminderDetails from "./invoice-reminder-details";
import InvoiceReminderContactList from "./invoice-reminder-contact-list";
import InvoiceReminderContactsEdit from "./invoice-reminder-contacts-edit";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";

import { pathOr } from "ramda";
import { checkTabListPermission } from "../../../../router/guard";
export const moduleRoute = "accounting";
export const submenuRoute = "invoice_reminders";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    InvoiceReminderDetails,
    InvoiceReminderContactList,
    InvoiceReminderContactsEdit
  },
  data: function() {
    return {
      active: -1,
      lockLoading: false
    };
  },
  mixins: [createDTGridHost(), createModalMixin("contact_invoices")],
  computed: {
    ...mapGetters(storeNS, {
      selectedInvoiceReminder: "selectedInvoiceReminder"
    }),
    invoiceReminderSidewindowTabs: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("tab_title_invoice_info")
        }
      ]);
    },
    invoice_reminder_id: function() {
      return this.$route.params.invoice_reminder_id;
    },
    calendarDateId: function() {
      return pathOr(
        undefined,
        ["cdate", "calendar_date_id"],
        this.selectedInvoice
      );
    },
    contact_relation_table: function() {
      return this.selectedInvoice.contact.getExternalTable();
    },
    invoiceSidewindowTabs: function() {
      return [
        {
          route: "overview",
          value: this.$t("tab_title_invoice_info"),
          vgi_id: "mandatory_infos"
        },
        {
          route: "invoice_lines",
          value: this.$t("invoice_lines"),
          vgi_id: "tab_title_invoice_lines"
        },
        {
          route: "payments",
          value: this.$t("payments"),
          vgi_id: "tab_title_payments"
        },
        {
          route: "forwarding",
          value: this.$t("tab_title_forwarding"),
          vgi_id: "tab_title_forwarding"
        }
      ];
    },
    invoiceObj: function() {
      return pathOr(undefined, ["invoice"], this.selectedInvoice);
    },
    lock_flag: function() {
      return pathOr("", ["invoice", "lock_flag"], this.selectedInvoice);
    },
    status_color: function() {
      return pathOr("", ["invoice", "status_color"], this.selectedInvoice);
    }
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.SelectedInvoice.UPDATE.SINGLE,
      ActionTypes.UPDATE_VAT_NO,
      ActionTypes.LOCK_INVOICE,
      ActionTypes.InvoiceLines.UPDATE.SINGLE,
      ActionTypes.CHANGE_TAX_DEDUC,
      ActionTypes.Payments.UPDATE.SINGLE,
      ActionTypes.SelectedInvoiceReminder.DELETE.SINGLE
    ]),
    closeInvoiceReminderDetails: function() {
      this.$emit("closeInvoiceReminderDetails", true);
    },

    onContactInvoicesCancelled: function() {},

    onInvoiceReminderContactDeleted: function(item) {
      // console.log('invoice contact ', item);
      this[ActionTypes.SelectedInvoiceReminder.DELETE.SINGLE](item);
    }
    // MARK: Methods

    // onInvoiceChange: function(payload) {
    //   this[ActionTypes.SelectedInvoice.UPDATE.SINGLE]({
    //     ...payload,
    //     invoice_id: this.invoiceObj.invoice_id,
    //     contact_id: this.invoiceObj.contact_id
    //   });
    // },
    // onInvoiceTaxDeduc: function({name, value}) {
    //   this[ActionTypes.CHANGE_TAX_DEDUC]({
    //     invoice_id: this.invoiceObj.invoice_id,
    //     vat_handling: this.invoiceObj.vat_handling,
    //     tax_type_id_deduction: this.invoiceObj.tax_type_id_deduction,
    //     [name]: value
    //   });
    // },
    // onInvoiceVatUpdate: function(payload) {
    //   this[ActionTypes.UPDATE_VAT_NO]({
    //     ...payload,
    //     contact_id: this.invoiceObj.contact_id
    //   });
    // },

    // onNotesBlur: function(event) {
    //   this.onInvoiceChange({
    //     name: 'notes',
    //     value: event.target.value
    //   });
    // },
    // onSubjectBlur: function() {
    //   this.onInvoiceChange({
    //     name: 'subject',
    //     value: event.target.value
    //   });
    // },
    // onInvoiceTextboxBlur: function(name, value) {
    //   this.onInvoiceChange({
    //     name,
    //     value
    //   });
    // },
    // onRefreshClick: function() {

    // },
    // onInvoiceMailClick: function() {
    //   sendInvoiceMail(this.selectedInvoice.invoice);
    // },
    // onInvoicePrintClick: function() {
    //   const { invoice_id } = this.selectedInvoice.invoice;
    //   if (invoice_id) {
    //     const newWindow = openWindow(
    //       `${HttpClient.getBaseUrl()}/accounting.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`
    //       , 'Print Invoice','height=200,width=150')
    //   }
    // },
    // onInvoiceEditClick: function() {
    //   this.$router.push({
    //     ...this.$route,
    //     query: {
    //       modal: 'set_status',
    //       invoice_id: this.selectedInvoiceId
    //     }
    //   });
    // },
    // onInvoiceLockClick: function() {
    //   this[ActionTypes.LOCK_INVOICE] ({
    //     from: 'details',
    //     invoice: this.selectedInvoice.invoice
    //   });
    // },
    // onGotoBookingClick: function() {
    //   if (this.calendarDateId) {
    //     this.$router.push({
    //       name: bookingListCalendarDateTabRoute,
    //       params: {
    //         calendar_date_id: this.calendarDateId,
    //         tab: 'overview'
    //       },
    //       query: {
    //         from: encodeRoute(this.$route)
    //       }
    //     });
    //   }
    // },
    // onInvoiceLineChange: function(payload) {
    //   this[ActionTypes.InvoiceLines.UPDATE.SINGLE](payload);
    // },
    // onPaymentChange: function(payload) {
    //   this[ActionTypes.Payments.UPDATE.SINGLE](payload);
    // },
    // onPaymentCurrencyChange: function(payload) {
    //   this[ActionTypes.Payments.UPDATE.SINGLE](payload);
    // },
    // ...mapActions(storeNS, {
    //   [ActionTypes.selectedInvoiceGroups.DELETE.SINGLE]: ActionTypes.selectedInvoiceGroups.DELETE.SINGLE,
    //   [ActionTypes.selectedInvoice.UPDATE.SINGLE]: ActionTypes.selectedInvoice.UPDATE.SINGLE,
    //   [ActionTypes.selectedInvoiceRelatedContacts.UPDATE.SINGLE]: ActionTypes.selectedInvoiceRelatedContacts.UPDATE.SINGLE,
    //   [ActionTypes.selectedInvoiceRelatedContacts.DELETE.SINGLE]: ActionTypes.selectedInvoiceRelatedContacts.DELETE.SINGLE,
    //   [ActionTypes.ContactFiles.DELETE.SINGLE]: ActionTypes.ContactFiles.DELETE.SINGLE,
    //   [ActionTypes.ContactFields.SET.ALL]: ActionTypes.ContactFields.SET.ALL,
    //   [ActionTypes.SET_PROVIDER_DATA]: ActionTypes.SET_PROVIDER_DATA,
    //   [ActionTypes.ContactAccountingInfo.UPDATE.ALL]: ActionTypes.ContactAccountingInfo.UPDATE.ALL,
    // }),
    //
    // onselectedInvoiceNoteBlur: function(event) {
    //   console.log(event);
    //   const { value }  = event.target;
    //   this[ActionTypes.selectedInvoice.UPDATE.SINGLE]({name: 'notes', value});
    // },
    // onGroupDelete: function(group) {
    //   this[ActionTypes.selectedInvoiceGroups.DELETE.SINGLE](group);
    // },
    // onContactChange: function({name, value}) {
    //   this[ActionTypes.selectedInvoice.UPDATE.SINGLE]({name, value});
    // },
    // onRelatedContactDelete: function(contact) {
    //   this[ActionTypes.selectedInvoiceRelatedContacts.DELETE.SINGLE](contact);
    // },
    // onRelatedContactChange: function({name, value, item}) {
    //   this[ActionTypes.selectedInvoiceRelatedContacts.UPDATE.SINGLE]({
    //     name,
    //     value,
    //     item
    //   });
    // },
    // onFileDelete: function(file) {
    //   this[ActionTypes.ContactFiles.DELETE.SINGLE](file);
    // },
    // onCustomFieldsChanged: function(fields) {
    //   this[ActionTypes.ContactFields.SET.ALL](fields);
    // },
    // onExportVCardClick: function() {
    //   const vCardURL = ContactsService.exportVCardURL({
    //     contact_id: this.selectedInvoiceId
    //   });
    //   window.open(vCardURL, 'VCard');
    // },
    // onDuplicateContactClick: async function(event) {
    //   const duplicatedContact = await ContactsService.duplicateContact({
    //     contact_id: this.selectedInvoiceId
    //   });
    //   this.$emit('fetch', true);
    //   this.$router.push({
    //     name: contactListLDTRoutes.names.details,
    //     params: {
    //       contact_id: duplicatedContact.data.contact_id
    //     }
    //   });
    // },
    // onContactDelete: async function() {
    //   const invoiceRelation = await ContactsService.checkInvoiceRelation({
    //     contact_id: this.selectedInvoiceId,
    //   });
    //   console.log(invoiceRelation.data.has_invoice_relation)
    //   if (invoiceRelation.data.has_invoice_relation == 'no') {
    //     ConfirmationService.create({
    //       subject: 'Delete Contact',
    //       body: 'Do you really want to delete the contact ?',
    //       completed: res => {
    //         switch(res) {
    //           case 'OK': {
    //             ContactsService.removeCompanyContact({
    //               contact_id: this.selectedInvoiceId
    //             }).then(res => {
    //               this.$router.push({
    //                 name: contactListLDTRoutes.names.list
    //               });
    //               this.$emit('fetch', true);
    //             });
    //             break;
    //           }
    //           default: {

    //           }
    //         }
    //       }
    //     })
    //   }
    // },
    // tabSelected: function(e) {
    //   this.$router.push({
    //     name: contactListLDTRoutes.names.tab,
    //     params: {
    //       artist_id: this.$route.params.contact_id,
    //       tab: this.contactSidewindowTabs[e].route
    //     }
    //   });
    // },
    // onProviderUpdate: function(payload) {
    //   this[ActionTypes.SET_PROVIDER_DATA](payload);
    // },
    // onAccountingInfoChange: function({name, value}) {
    //   console.log(name, value);
    //   this[ActionTypes.ContactAccountingInfo.UPDATE.ALL]({
    //     kVal: this.selectedInvoiceId,
    //     name,
    //     value
    //   });
    // }
  }
};
</script>

<style lang="scss">
.cmp-accounting-invoice_reminder-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 129px);
  }
}
</style>
